import React from "react";
import "../Styles/PaymentCancelled.css";

import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

export default function PaymentCancelled() {
  const navigate = useNavigate();

  return (
    <>
    <Header/>

    <div className="cancel-container">
      <div className="cancel-card">

      

        <div className="cancel-icon">✕</div>

        <h1>Payment Not Completed</h1>

        <p className="cancel-subtitle">
          No worries your payment wasn't completed and you haven't been charged.
          You can try again whenever you're ready.
        </p>

        <button
          className="cancel-btn"
          onClick={() => navigate("/product")}
        >
          Try Again
        </button>

        <button
          className="cancel-secondary-btn"
          onClick={() => navigate("/#contact-us")}
        >
          Need Help?
        </button>

        <p className="cancel-note">
          Having trouble checking out? Contact ClusterClear support and we'll help
          you complete your order.
        </p>

      </div>
    </div>

    <Footer/>

</>
  );
}